import { FullscreenPage } from '@/components/ui';
import { useNarrativeStore } from '@/engine/state';

export function LogPage() {
  const decisiones = useNarrativeStore((s) => s.decisiones);

  return (
    <FullscreenPage
      titulo="Log de decisiones"
      subtitulo={`${decisiones.length} registrada${decisiones.length !== 1 ? 's' : ''}`}
    >
      {decisiones.length === 0 ? (
        <p className="text-narrative italic text-ash-500 fluid-base">
          Todavía no tomaste decisiones de peso. Cuando lo hagas, quedarán
          registradas acá, con sus consecuencias inmediatas y las que tardan
          en manifestarse.
        </p>
      ) : (
        <ul className="space-y-3">
          {decisiones.map((d) => (
            <li key={d.id} className="border-l-2 border-moss-700/60 pl-3">
              <p className="text-narrative text-ash-200 fluid-base">{d.textoOpcion}</p>
              <p className="fluid-xs text-ash-500 font-ui mt-0.5">Escena {d.sceneId}</p>
              {d.impactoInmediato && (
                <p className="fluid-sm text-moss-300 mt-1">{d.impactoInmediato}</p>
              )}
              {d.consequencePendiente && !d.impactoDiferidoResuelto && (
                <p className="fluid-sm italic text-mystic-400 mt-1">
                  Próximamente lo sabrás...
                </p>
              )}
              {d.impactoDiferidoResuelto && (
                <p className="fluid-sm text-ember-300 mt-1">{d.impactoDiferidoResuelto}</p>
              )}
            </li>
          ))}
        </ul>
      )}
    </FullscreenPage>
  );
}
